import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { WINDOW } from '@upr-web-primer/window';
import { get, isEmpty } from 'lodash-es';

class AdobeTargetService {
    constructor(window) {
        this.window = window;
        if (get(this.window, 'adobe.target.VERSION')) {
            this.adobeTarget = this.iterationCopy(this.window.adobe.target);
        }
    }
    setMbox(mBox) {
        this.mBox = mBox;
    }
    getABTestOffer() {
        const mBox = this.mBox || 'target-global-mbox';
        this.getOffer({
            mbox: mBox
        })
            .then((offers) => {
            const html = this._clean(this.window.document.getElementsByTagName('html')[0].innerHTML);
            const offersNotOnPage = [];
            console.log('---> Received offers: ', offers);
            offers.map((offer) => {
                if (html.indexOf(this._clean(offer.content)) > -1) {
                    console.log({ '---> offer already on the page': offer });
                }
                else {
                    offersNotOnPage.push(offer);
                    console.log({ '---> Appliying offer': offer });
                }
            });
            if (!isEmpty(offersNotOnPage) && offersNotOnPage.length) {
                this.adobeTarget.applyOffer({
                    mbox: mBox,
                    offer: offersNotOnPage
                });
            }
        })
            .catch((e) => {
            console.error('---> Error on getOffer', e);
        });
    }
    getOffer(opts) {
        return new Promise((resolve, reject) => {
            if (!this.checkAdobeTarget()) {
                return reject('Adobe Target empty');
            }
            opts = opts || {};
            if (!opts.mbox) {
                reject('Mbox name not specified!');
            }
            const atOpts = {
                mbox: opts.mbox,
                params: opts.params,
                timeout: opts.timeout,
                success: (response) => {
                    if (response && response.length > 0) {
                        console.log('---> Adobe Target getOffer: offers', response);
                        resolve(response);
                    }
                    else {
                        console.log('---> Adobe Target getOffer: Empty offer');
                        reject('Empty offer');
                    }
                },
                error: (error) => {
                    reject(error);
                }
            };
            this.window.adobe.target.getOffer(atOpts);
        });
    }
    applyOffer(offer) {
        console.log('---> Adobe Target applyOffer: ', offer);
        return new Promise((resolve, reject) => {
            if (!this.checkAdobeTarget()) {
                return reject('Adobe Target empty');
            }
            this.window.adobe.target.applyOffer(offer);
            resolve(true);
        });
    }
    checkAdobeTarget() {
        if (!get(this.window, 'adobe.target.VERSION')) {
            if (get(this.adobeTarget, 'VERSION')) {
                this.window.adobe.target = this.adobeTarget;
                return true;
            }
            else {
                console.log('---> getOffer: Adobe Target empty');
                return false;
            }
        }
        return true;
    }
    iterationCopy(src) {
        const target = {};
        for (const prop in src) {
            if (src.hasOwnProperty(prop)) {
                target[prop] = src[prop];
            }
        }
        return target;
    }
    _clean(text) {
        return (text || '')
            .replace(/(\s|;|\r\n\t|\n|\r\t)/gm, '')
            .toLocaleLowerCase();
    }
}
AdobeTargetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AdobeTargetService, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
AdobeTargetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AdobeTargetService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AdobeTargetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

export { AdobeTargetService };
